import { themeColors } from '@/theme/palette';

export const HEADER_HEIGHT = '44px';

export const MULTIPLE_COLORS = [
  '#3992ee',
  '#924CEC',
  '#ED6C68',
  '#5E9839',
  '#EAA53D',
  '#FF8C00', // Dark Orange
  '#20B2AA', // Light Sea Green
  '#FF4500', // Orange Red
  '#32CD32', // Lime Green
  '#8B4513', // Saddle Brown
];

export const MULTIPLE_COLORS_OVERVIEW: Record<number, string> = {
  0: themeColors.info.main,
  1: themeColors.warning.main,
  2: themeColors.error.main,
};
export const MULTIPLE_COLORS_AMOUNT = Object.keys(MULTIPLE_COLORS).length;
export const MULTIPLE_COLORS_OVERVIEW_AMOUNT = Object.keys(MULTIPLE_COLORS_OVERVIEW).length;

export const COLORS = {
  VIOLET: '#606ACB',
  VIOLET_20: 'rgb(96, 106, 203, 0.1)',
  BORDER: '#161616',
  NEGATIVE: '#DA615C',
  POSITIVE: '#718DBC',
  NEGATIVE_20: 'rgb(218, 97, 92, 0.1)',
  POSITIVE_20: 'rgb(113, 141, 188, 0.10)',
  ACCENT: '#A1A1AA',
  ACCENT_20: 'rgba(161, 161, 170, 0.2)',
  LINK_20: 'rgba(57, 146, 238, 0.2)',
  LINK: '#3992EE',
  yellowv2: '#D6EC4C',
  yellowv2bg: '#D6EC4C44',
};

export const background = '#09090b';
